import { MAX_USER_LEVEL, MIN_USER_LEVEL, UserLevel } from '../types';

export const useUserLevel = () => {
	const userLevelRaw = sessionStorage.getItem('level');
	if (!userLevelRaw) {
		return undefined;
	}

	const userLevel = parseInt(userLevelRaw);
	if (Number.isNaN(userLevel)) {
		return undefined;
	}

	if (userLevel < MIN_USER_LEVEL || userLevel > MAX_USER_LEVEL) {
		return undefined;
	}

	return userLevel as UserLevel;
};
